import { computed, toValue } from "vue";

/**
 * Returns whether the date selector sits in the results list layout: the list placement outside the map view.
 *
 * @param {import("vue").MaybeRefOrGetter<string>} placement the selector's placement
 * @param {import("vue").MaybeRefOrGetter<string>} view the finder's current view
 * @returns {import("vue").ComputedRef<boolean>}
 */
export function useListLayout(placement, view) {
  return computed(() => toValue(placement) === "list" && toValue(view) !== "map");
}
